import React from 'react';
import { class3Inspection as tooltip } from 'pu-data/Tooltips';
import RadioDualComponent from './RadioDualComponent';

const Class3Inspection = (props) => {
  const name = 'class_3_inspection';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <RadioDualComponent
      name={name}
      label="Class III Inspection"
      tooltip={props.tooltip}
      onChange={onChange}
      parameters={props.parameters}
      className={props.className} />
  );
};

Class3Inspection.defaultProps = {
  tooltip,
  className: 'class-3-inspection',
};

export default Class3Inspection;
